import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

export type IOdbUsageLevelFourPaginationSizeOption = 10 | 20 | 50 | 100;
export type IOdbUsageLevelFourTableEvents =
  | {
      name: 'changePageSize';
      target: IOdbUsageLevelFourPaginationSizeOption;
    }
  | {
      name: 'changeCurrentPage';
      target: number;
    }
  | {
      name: 'goToPreviousPage';
    }
  | {
      name: 'goToNextPage';
    };

@Component({
  selector: 'my-bill-odb-usage-level-four-table-pagination',
  templateUrl: './odb-usage-level-four-table-pagination.component.html',
  standalone: false,
})
export class OdbUsageLevelFourTablePaginationComponent implements OnChanges {
  pageSizeOptions: IOdbUsageLevelFourPaginationSizeOption[] = [10, 20, 50, 100];

  @Input() currentPageSize?: IOdbUsageLevelFourPaginationSizeOption = 10;
  @Input() currentPageNumber: number;
  @Input() totalNumberOfItems: number;

  @Output() actions: EventEmitter<IOdbUsageLevelFourTableEvents> =
    new EventEmitter();

  rankOfFirstItemDisplayed: number;
  rankOfLastItemDisplayed: number;
  totalNumberOfPages: number;
  pagesThatCanBeDisplayed: number[] = [1];

  ngOnChanges() {
    this.rankOfFirstItemDisplayed =
      (this.currentPageNumber - 1) * this.currentPageSize + 1;
    this.rankOfLastItemDisplayed = Math.min(
      this.currentPageNumber * this.currentPageSize,
      this.totalNumberOfItems
    );
    this.totalNumberOfPages = Math.ceil(
      this.totalNumberOfItems / this.currentPageSize
    );
    this.pagesThatCanBeDisplayed = new Array(this.totalNumberOfPages)
      .fill(null)
      .map((_, i) => i + 1);
  }

  onPageSizeChange(target: string) {
    this.actions.emit({
      name: 'changePageSize',
      target: Number(target) as IOdbUsageLevelFourPaginationSizeOption,
    });
  }

  onCurrentPageChange(
    target: string | null,
    action?: 'goToNextPage' | 'goToPreviousPage'
  ) {
    if (target !== null) {
      this.actions.emit({
        name: 'changeCurrentPage',
        target: Number(target),
      });
    } else {
      this.actions.emit({
        name: action,
      });
    }
  }
}
